import {
    ApolloClient,
    HttpLink,
    ApolloLink,
    InMemoryCache,
    concat,
} from '@apollo/client';

const { env, apigeeToken, apigeeBaseUrl, routingKey } =
    window.__conf__;

// We're excluding credentials option on local environment while session issues are looked into
const credentials = env === 'local' ? null : 'include';
const production = env === 'prod';

const httpLink = new HttpLink({
    uri: `${apigeeBaseUrl}/sales/apply/v1/product-recommender/graphql`,
    credentials,
});
const authMiddleware = new ApolloLink((operation, forward) => {
    const commonHeaders = {
        Channel: 'WEB',
        'App-Id': 'APPLY',
        'Correlation-ID': sessionStorage.getItem('correlationId'),
        Authorization: `Basic ${btoa(apigeeToken)}`,
    };
    const envHeader = production
        ? commonHeaders
        : { ...commonHeaders, routingKey };
    operation.setContext(({ headers = {} }) => ({
        headers: {
            ...headers,
            ...envHeader,
        },
    }));

    return forward(operation);
});

export const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: concat(authMiddleware, httpLink),
});
